<template>
  <div>
    <div class="d-flex">
      <h2 class="titleText--text">Actual vs predicted</h2>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon  v-bind="attrs" size="medium"
              v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
            </template>
            <span> Actual vs predicted</span>
          </v-tooltip>
        </div>
    <v-card flat class="custom-shadow mt-2">
      <v-card-text>
        <div class="d-flex justify-center" v-if="!this.ishavedata">
          <v-progress-circular
            :size="50"
            color="blue"
            indeterminate
          ></v-progress-circular>
        </div>
        
        <div v-if="this.ishavedata" id="chart">
          <apexchart
            type="line"
            height="350"
            :options="chartOptionstbd"
            :series="seriesdatafull"
          ></apexchart>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
//import { bus } from "../../../main";
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import apifactorynew from "../api";

Vue.use(VueAxios, axios);
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    //for chart
    itemsplottemp: [],
    itemsplot: [],
    seriesnew: [],
    labelnew: [],
    series1: [
      {
        name: "TEAM A",
        type: "bar",
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
      },
      {
        name: "TEAM B",
        type: "line",
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
      },
      {
        name: "TEAM C",
        type: "line",
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      },
    ],
    chartshow: 0,
    chartOptions: {
      chart: {
        height: 350,
        type: "line",
        stacked: false,
        fontFamily: "Lato",
      },
      stroke: {
        curve: "smooth",
        width: 0,
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          barHeight: "80%",
        },
      },

      fill: {
        type: "solid",
      },
      markers: {
        size: 0,
      },
      xaxis: {
        type: "datetime",
        labels: {
          style: {
            color: "#9AA1A9",
            fontWeight: "bold",
          },
        },
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            colors: ["#9AA1A9"],
            fontWeight: "bold",
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y) {
            if (typeof y !== "undefined") {
              return y.toFixed(0) + " points";
            }
            return y;
          },
        },
      },
      grid: {
        show: false, // you can either change hear to disable all grids
        xaxis: {
          lines: {
            show: false, //or just here to disable only x axis grids
          },
        },
        yaxis: {
          lines: {
            show: false, //or just here to disable only y axis
          },
        },
      },
    },

    xaxismin: null,
    xaxismax: null,
    //end for chart
    //loading
    ishavedata: false,
    // charttbd
    chartOptionstbd: {
      chart: {
        height: 350,
        type: "line",
      },
      stroke: {
        width: [0, 4],
      },
      title: {
        text: "",
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [1],
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            colors: ["#9AA1A9"]
          },
        },
      },
      xaxis: {
        show: true,
        type: "datetime",
        labels: {
          style: {
            colors: ["#9AA1A9"]
          },
        },
      },
    },

    seriestbd1111: [
      {
        name: "error",
        type: "column",
        data: [
          1727.37, 3120.8, 1245.71, 1174.22, 82.42, -1330.75, 2223.45, 3120.8,
          -4172.29, -7285.78, 82.42, -1914.66, 3722.61, -4773.47, 5806.03,
          2389.78, -6611.58, 3708.51, -1478.97, -2660.91, -2153.99, 1277.27,
          4252.23, -1551.23,
        ],
      },
      {
        name: "predicted",
        type: "line",
        data: [
          38182.63, 37963.2, 41450.29, 40060.78, 39406.58, 44669.75, 37686.55,
          37963.2, 41450.29, 40060.78, 39406.58, 44494.66, 39139.39, 42942.47,
          47209.97, 44549.22, 45007.58, 46275.49, 43005.97, 48176.91, 42946.99,
          45588.73, 51978.77, 46860.23,
        ],
      },
      {
        name: "actual",
        type: "line",
        data: [
          39910, 41084, 42696, 41235, 39489, 43339, 39910, 41084, 37278, 32775,
          39489, 42580, 42862, 38169, 53016, 46939, 38396, 49984, 41527, 45516,
          40793, 46866, 56231, 45309,
        ],
      },
    ],

    seriesdatafull: [],
  }),

  methods: {
    onloadgotchart() {
      //alert('onloadgotchart123');
      this.getplot();
    },
    getplot() {
      this.ishavedata = false;
      apifactorynew
        .api_get_model_actual_predicted()
        .then((res) => {
          if (res.status != 200) {
            this.itemsplot = null;
            // alert(this.processdataitems.length);
          } else {
            let tempdata = [];
            tempdata = res.data.actual_predicted_chart;
            //alert(JSON.stringify(tempdata));
            this.itemsplot = tempdata.filter((a) => a.region == "national");
            //alert(JSON.stringify( this.itemsplot ));
            this.createchartseries();
            this.createnewseriesfull();
            this.ishavedata = true;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getplotOld() {
      apifactorynew
        .api_get_model_actual_predicted()
        .then((res) => {
          if (res.status != 200) {
            this.itemsplot = null;
            // alert(this.processdataitems.length);
          } else {
            let tempdata = [];
            tempdata = res.data.actual_predicted_chart;
            //alert(JSON.stringify(tempdata));
            this.itemsplot = tempdata.filter((a) => a.region == "national");
            //alert(JSON.stringify( this.itemsplot ));
            this.createchartseries();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "t_date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].t_date).getTime());
            var innerdata = [];
            //innerdata.push(k1);
            // let newval=new Date(this.itemsplot[i].t_date).getTime() + "," + this.itemsplot[i][k1];

            innerdata.push(new Date(this.itemsplot[i].t_date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;
      this.series = [];
      this.series = tkey;

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      //alert(mindate);

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          yaxis: {
            labels: {
              style: {
                colors: ["#9AA1A9"],
              },
            },
          },
          annotations: {
            yaxis: {
              show: false,
              labels: {
                style: {
                  colors: ["#9AA1A9"],
                },
              },
            },
            xaxis: [
              {
                x: mindate,
                borderColor: "#999",
                yAxisIndex: 0,

                label: {
                  show: true,
                  formatter: function (val) {
                    return "YY-" + val;
                  },
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#775DD0",
                  },
                },
              },
            ],
          },
        },
      };
      this.chartshow = 1;
    },

    createchartseries() {
      this.seriesnew = [];

      //
      let objError = new Object();
      objError.name = "error";
      objError.type = "bar";
      let objErrordata = [];
      for (var k2 = 0; k2 < this.itemsplot.length; k2++) {
        objErrordata.push(this.itemsplot[k2].error);
      }
      objError.data = objErrordata;

      this.seriesnew.push(objError);

      //
      let objPredicted = new Object();
      objPredicted.name = "predicted";
      objPredicted.type = "line";
      let objPredicteddata = [];
      for (var k = 0; k < this.itemsplot.length; k++) {
        objPredicteddata.push(this.itemsplot[k].predicted);
      }
      objPredicted.data = objPredicteddata;

      this.seriesnew.push(objPredicted);

      let objActual = new Object();
      objActual.name = "actual";
      objActual.type = "line";
      let objActualdata = [];
      for (var i = 0; i < this.itemsplot.length; i++) {
        objActualdata.push(this.itemsplot[i].actual);
      }
      objActual.data = objActualdata;

      this.seriesnew.push(objActual);

      //label
      this.labelnew = [];
      // let objlabeldata = [];
      for (var k3 = 0; k3 < this.itemsplot.length; k3++) {
        //objlabeldata.push(this.itemsplot[k3].Period);
        this.labelnew.push(this.itemsplot[k3].period);
      }
      // objError.data = objErrordata;

      //this.labelnew.push(objlabeldata);
      this.chartOptions = {
        labels: this.labelnew,
      };
    },
    Refresh() {
      alert("refreshmodelmixchart");
      //this.getplot();
    },

    createnewseriesfull() {
      //alert("dddd");
      let templist = [];
      let obj = new Object();
      obj.name = "error";
      obj.type = "column";
      obj.data = this.geterrorseriesdata();
      templist.push(obj);

      let obj1 = new Object();
      obj1.name = "predicted";
      obj1.type = "line";
      obj1.data = this.getpredictedseriesdata();
      templist.push(obj1);

      let obj2 = new Object();
      obj2.name = "actual";
      obj2.type = "line";
      obj2.data = this.getactualseriesdata();
      templist.push(obj2);

      //alert(JSON.stringify(templist));
      this.seriesdatafull = templist;
      this.chartOptionstbd = {
        ...this.chartOptionstbd,
        ...{
          labels:this.getdatelabelsforchart()
        }
      }
      /*
       this.seriesdatafull= [{
          name: 'error',
          type: 'column',
          data: this.geterrorseriesdata()
        }, {
          name: 'Predicted',
          type: 'line',
          data: this.getpredictedseriesdata()
        },
         {
          name: 'Actual',
          type: 'line',
          data: this.getactualseriesdata()
        }
        ];*/
      //alert('ddddd');
    },
    getactualseriesdata() {
      let seriesdata = [];
      for (let k in this.itemsplot) {
        seriesdata.push(this.itemsplot[k]["actual"]);
      }
      return seriesdata;
    },
    geterrorseriesdata() {
      let seriesdata = [];
      for (let k in this.itemsplot) {
        seriesdata.push(this.itemsplot[k]["error"]);
      }

      return seriesdata;
    },
    getpredictedseriesdata() {
      let seriesdata = [];
      for (let k in this.itemsplot) {
        seriesdata.push(this.itemsplot[k]["predicted"]);
      }
      return seriesdata;
    },
 getdatelabelsforchart() {
      let seriesdata = [];
      for (let k in this.itemsplot) {
        seriesdata.push(this.itemsplot[k]["date"]);
      }
      return seriesdata;
    }
    //new

    //end
  },
  mounted() {
    this.getplot();
    //bus.$off("refreshmodelmixchart");
    //bus.$on("refreshmodelmixchart", this.Refresh);
  },
  computed: {
    getdatelabels() {
      let seriesdata = [];
      for (let k in this.itemsplot) {
        seriesdata.push(this.itemsplot[k]["date"]);
      }
      return seriesdata;
    },
  },
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}

.selectedbtn {
  background-color: #0177b2 !important;
  color: white !important;
}

.nonselectedbtn {
  background-color: lightgrey !important;
  color: black !important;
  /* opacity: 40%;*/
}

.errorlog {
  background-color: rgba(255, 0, 0, 0.274);
  color: black;
}

.nonerrorlog {
  background-color: rgba(0, 128, 0, 0.377);
  color: black;
}
</style>
